module.exports = __webpack_public_path__ + "static/media/on-eye_classic-Charm.ac84a2e4.jpg";